<template>
    <div id="recommendedService" class="recommended-service" v-if="data && data.length > 0">
        <van-tabs v-model="actived" :ellipsis="false" shrink @rendered="rendered">
            <van-tab v-for="(item, index) in data" :key="index" :title="item.objectName" >
                <div class="swiper swiperFast">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(balance, index) in fastEntryListComputed" :key="index">
                            <div class="fast-div-list">
                                <div class="div-default" v-for="(it, idx) in balance" :key="idx" @click="serviceJump(it)">
                                    <span :class="'color' + idx">
                                        <img
                                            class="icon-img"
                                            onload="SVGInject(this)"
                                            round
                                            fit="cover"
                                            :src="complete(it.icon)"
                                        />
                                    </span>
                                    <p>{{ it.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import { Tab, Tabs } from "vant"
    import { complete, baseURL } from "@/utils/url"
    import * as svg from "@/utils/svg-inject.min"
    import { getHotService } from "@/api/home/index"
    import { serviceJump } from "@/utils/serviceUtil"
    import Swiper from "swiper"
    export default {
        name: "RecommendedService",
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        data() {
            return {
                actived: 0,
                basePath: baseURL,
                data: [],
            }
        },
        computed: {
            fastEntryListComputed() {
                let pages = []
                let list = this.data[this.actived].serviceList
                list.forEach((item, index) => {
                    let idx = Math.floor(index / 8)
                    if (!pages[idx]) pages[idx] = []
                    pages[idx].push(item)
                })
                return pages
            },
        },
        created() {
            this.getServiceList()
        },
        methods: {
            complete,
            //获取推荐服务及服务对象
            getServiceList() {
                getHotService().then(res => {
                    if (res && res.code == 200) {
                        this.data = res.data
                    }
                })
            },
            serviceJump,
            handleSwiper() {
                this.$nextTick(() => {
                    this.rendered()
                })
            },
            rendered() {
                new Swiper(".swiperFast", {
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next2",
                        prevEl: ".swiper-button-prev2",
                    },
                })
            },
        },
    }
</script>

<style lang="scss">
    @import "~@/assets/css/theme/theme.scss";
    //.van-tab--active
    #recommendedService {
        .swiperFast {
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
            .fast-div-list {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                margin: auto;
                justify-content:flex-start;
                .div-default {
                    position: relative;
                    width: 25%;
                    box-sizing: border-box;
                    flex: 0 0 25%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 0 10px;
                    span {
                        display: inline-block;
                        width: 45px;
                        height: 45px;
                        padding: 10px;
                        box-sizing: border-box;
                        border-radius: 23px;
                        font-size: 21px;
                        text-align: center;
                        line-height: 45px;

                        img,
                        svg {
                            display: block;
                            width: 25px;
                            height: 25px;
                            fill: #ffffff;
                        }

                        &.color0,
                        &.color5 {
                            background: linear-gradient(-45deg, #f55359, #fd896c);
                        }
                        &.color1,
                        &.color7 {
                            background: linear-gradient(-45deg, #faa452, #fedc72);
                        }
                        &.color2,
                        &.color4 {
                            background: linear-gradient(-45deg, #5766f7, #6cabf5);
                        }
                        &.color3,
                        &.color6 {
                            background: linear-gradient(-45deg, #28d1a7, #4ae7b7);
                        }
                    }

                    p {
                        //height: 20px;
                        margin-top: 6px;
                        color: $c333;
                        line-height: 20px;
                        display: -webkit-box;
                        overflow: hidden;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        //text-align: center;
                        //white-space: nowrap;
                        //overflow: hidden;
                        text-overflow: ellipsis;
                        @extend .font14;
                    }
                }
            }
        }

        .van-tab--active {
            font-size: 16px;
            font-weight: 600;
        }
        .van-tabs__line {
            display: none;
        }
    }
</style>
